import { render } from "./AppHeader.vue?vue&type=template&id=3518adad&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=3518adad&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Song\\Documents\\Fun\\snapshot\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3518adad"]])

export default __exports__